module.exports = "/_next/static/images/a122772d5e600e43c86c48eae8fda1d4-pj-person-making-card-purchase@0.75x.jpg.webp";